import {
    EDIT_INTERVIEWER_BY_ADMIN_REQUEST,
    EDIT_INTERVIEWER_BY_ADMIN_SUCCESS,
    EDIT_INTERVIEWER_BY_ADMIN_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editInterviewerByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_INTERVIEWER_BY_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_INTERVIEWER_BY_ADMIN_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_INTERVIEWER_BY_ADMIN_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editInterviewerByAdminReducer;
